import { createContext } from 'react'

import { BreadcrumbsContextType } from './BreadcrumbsContext.types'

export const BreadcrumbsContext = createContext<BreadcrumbsContextType | undefined>(undefined)
